import React, { useState } from "react";
import classes from "./Header.module.css";
import translate from "../../service/Language";

function Header() {
    const [image1, setImage1] = useState("");
    const [image2, setImage2] = useState("");
    const [image3, setImage3] = useState("");


    if (window.innerWidth > 1190) {
        window.addEventListener("scroll", () => {
            setImage1(window.scrollY / 8);
            setImage2(window.scrollY / 8);
            setImage3(window.scrollY / 4);
        });
    }


    return (
        <div className={classes.Header}>
            <div className={classes.Left}>
                <div className={classes.images}>
                    <img
                        className={classes.header_1}
                        src="/images/header_1.jpg"
                        alt=""
                        style={{ marginBottom: image1 + "px" }}
                    />
                    <img
                        className={classes.header_2}
                        src="/images/header_2.jpg"
                        alt=""
                        style={{ marginBottom: image2 + 100 + "px" }}
                    />
                    <img
                        className={classes.header_3}
                        src="/images/header_3.jpg"
                        alt=""
                        style={{ marginTop: -image3 + -80 + "px" }}
                    />
                </div>
            </div>
            <div className={classes.Right}>
                <h2>
                    {translate("ДЕТСКИЙ МАГАЗИН", "BOLALAR DO'KONI")} <br />{" "}
                    {translate("MEHRIBON SHOP", "MEHRIBON SHOP")}
                </h2>
                <p>
                    {translate("Вязаные поделки для ваших детей в нашем интернет-магазине продукты создаются.", "Bizning Onlayn do'konimizda bolalaringiz uchun to'qilgan qo'l mehnati  mahsulotlari yaratiladi.")}
                </p>
                <p>
                    {translate("Товары нашего магазина: вязаные кроватки, шапочки, шарфы, варежки, детские рюкзаки, корзины разных размеров, пледы, пенеты, ковры для детских комнат.", "Do'konimiz mahsulotlari: to'qilgan beshiklar, bosh kiyimlar, sharflar, qo'lqopchalar, bolalar uchun ryukzaklar, turli o'lchamdagi savatlar,  pledlar, penetlar, bolalar xonasi uchun gilamlar.")}

                </p>
                <h4>{translate("С БЕСКОНЕЧНОЙ ЛЮБОВЬЮ", "CHEKSIZ MEHR-MUHABBAT BILAN")}</h4>
            </div>
        </div>
    );
}

export default Header;
